import type { OfficeCity } from '../../core/models/office-city';
import { OFFICE_CITIES } from '../../core/models/office-cities';
import type { Specialist } from '../../core/models/specialist';

/**
 * The cities the toggle should offer: the offices that actually have somebody in them, in the order
 * the site lists them.
 *
 * **Derived rather than fixed**, which is the difference between this and the build-time list it
 * replaces. That one hard-coded both cities, which was true because the constant array was written
 * with both filled in; a toggle built the same way over live data offers a tab that scrolls an empty
 * row the day nobody in Almaty has their card switched on.
 */
export function citiesWithSpecialists(specialists: readonly Specialist[]): readonly OfficeCity[] {
    return OFFICE_CITIES.filter((city) => specialists.some((specialist) => specialist.city === city));
}
